import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Home.css";

//cool color: "rgb(196, 46, 46)"

function HomePage() {
  return (
    <Container>
        <Row className="justify-content-center">
            <Col xl={8} lg={8} md={8} sm={12}>
                <Container fluid style={{ backgroundColor: "black", padding: 0, marginTop: "10%"}}>
                <div style={{ backgroundColor: "#00838F", display: "flex", justifyContent: "space-between", alignItems: "center", height: "max-content" }}>
                    <h1 style={{ color: "white", paddingLeft: "1%", paddingRight: "1%"}}>About me: Adam Scott</h1>
                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        poster={process.env.PUBLIC_URL + "outdoor.jpg"}
                        style={{ maxWidth: "40%", maxHeight: "40%" }}
                    >
                        <source
                        src={process.env.PUBLIC_URL + "head_spinning.mp4"}
                        type="video/mp4"
                        />
                        Your browser does not support the video tag.
                    </video>
                    {/* <img src={process.env.PUBLIC_URL + "outdoor.jpg"} alt="Proof that I go outside" style={{ maxWidth: "40%", maxHeight: "40%" }} /> */}
                </div>
                <div style={{ backgroundColor: "black", color: "white", paddingTop: "5%", paddingBottom: "15%", marginLeft: "2%", marginRight: "2%"}}>
                    <p style={{ textAlign: "left"}}>
                    Hey, I'm Adam Scott. I'm a software engineer at HII Mission Technologies. Before that I did my master's in computer science at NC State where I helped publish a couple of papers. If you're curious, here they are.
                    </p>
                    <br/>
                    <br/>

                    <a href="https://ieeexplore.ieee.org/document/10804561" target="_blank" rel="noopener noreferrer">
                    https://ieeexplore.ieee.org/document/10804561
                    </a>
                    <br />
                    <a href="https://github.com/ncsu-swat/incompleter" target="_blank" rel="noopener noreferrer">
                    GitHub: ncsu-swat/incompleter
                    </a>

                    <br/>
                    <br/>

                    <a href="https://dl.acm.org/doi/10.1145/3650212.3680320" target="_blank" rel="noopener noreferrer">
                    https://dl.acm.org/doi/10.1145/3650212.3680320
                    </a>
                    <br />
                    <a href="https://github.com/ncsu-swat/chatassert" target="_blank" rel="noopener noreferrer">
                    GitHub: ncsu-swat/chatassert
                    </a>
                </div>
                </Container>
            </Col>
        </Row>
    </Container>
  );
}

export default HomePage;